export default "/images/vendor/flag-icon-css/flags/1x1/mt.svg?0c23ea353ac917d9e4d486a9af72e221";